import { Row, Col, Table, Spinner, Form } from 'react-bootstrap';
import { useState, useEffect } from 'react';

export default function ListagemServidores() {
    const [servidores, setServidores] = useState([]);
    const [loading, setLoading] = useState(true);
    const [ano, setAno] = useState(new Date().getFullYear());
    const [mes, setMes] = useState(new Date().getMonth() + 1); // Janeiro = 0

    const carregarServidores = () => {
        setLoading(true);
        fetch(`https://dadosabertos.alepe.pe.gov.br/api/v1/servidores/?ano=${ano}&mes=${mes}`)
            .then(result => result.json())
            .then(data => {
                setServidores(data);
                setLoading(false);
            });
    };

    useEffect(() => {
        carregarServidores();
    }, [ano, mes]);

    const anosDisponiveis = [];
    for (let y = 2023; y <= new Date().getFullYear(); y++) anosDisponiveis.push(y);

    const meses = [
        "Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho",
        "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"
    ];

    return (
        <Row>
            <Col xs="12">
                <p>
                    <small>
                        Você está em <a href="/pessoal">Gestão de Pessoas</a> / Listagem de Pessoal
                    </small>
                </p>
            </Col>
            <Col xs="12" md="6">
                <Form.Group controlId="filtroAno">
                    <Form.Label>Ano</Form.Label>
                    <Form.Select value={ano} onChange={(e) => setAno(Number(e.target.value))}>
                        {anosDisponiveis.map(a => (
                            <option key={a} value={a}>{a}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            <Col xs="12" md="6">
                <Form.Group controlId="filtroMes">
                    <Form.Label>Mês</Form.Label>
                    <Form.Select value={mes} onChange={(e) => setMes(Number(e.target.value))}>
                        {meses.map((nome, index) => (
                            <option key={index} value={index + 1}>{nome}</option>
                        ))}
                    </Form.Select>
                </Form.Group>
            </Col>
            {!loading ? (
                <Col xs="12">
                    <Row>
                        <Col xs={{ span: 2, offset: 10 }} className="mb-2 text-center">
                            <div>
                                <a
                                    href={`https://dadosabertos.alepe.pe.gov.br/api/v1/servidores/?formato=csv&ano=${ano}&mes=${mes}`}
                                    title="Download em CSV"
                                >
                                    <img src="/img/download-csv.png" height="16" width="16" alt="" />
                                    CSV
                                </a>
                            </div>
                        </Col>
                    </Row>
                    <div className="table-responsive" style={{ fontSize: '0.85rem' }}>
                        <Table striped bordered hover>
                            <thead>
                                <tr>
                                    <th>Nome</th>
                                    <th>Cargo</th>
                                    <th>Cargo Efetivo</th>
                                    <th>Lotação</th>
                                    <th>Vínculo</th>
                                    <th>Data de Admissão</th>
                                    <th>Carga Horária</th>
                                </tr>
                            </thead>
                            <tbody>
                                {servidores.map((servidor, index) => (
                                    <tr key={index}>
                                        <td>{servidor.NOME}</td>
                                        <td>{(servidor.VINCULO !== "Efetivo" || servidor.CARGO_NIVEL !== servidor.CARGO_EFETIVO) ? servidor.CARGO_NIVEL : ''}</td>
                                        <td>{servidor.VINCULO === "Efetivo" ? servidor.CARGO_EFETIVO : ""}</td>
                                        <td>{servidor.NOME_LOTACAO}</td>
                                        <td>{servidor.VINCULO}</td>
                                        <td>{new Date(servidor.DATA_ADMISSAO?.date).toLocaleDateString('pt-BR')}</td>
                                        <td>30h</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </div>
                </Col>
            ) : (
                <Col xs="12" className="text-center">
                    <Spinner />
                </Col>
            )}
        </Row>
    );
}
